import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

/** v7 `.home-att-row` — one actionable item in the "Needs attention" card. */
const HomeAttentionRow = ({
  icon,
  tone = 'warn',
  title,
  detail,
  action,
  onClick,
}) => (
  <button type='button' className='experience-home-att-row' onClick={onClick}>
    <span
      className={classNames('experience-home-att-icon', {
        danger: tone === 'danger',
      })}
      aria-hidden='true'>
      {icon}
    </span>
    <div>
      <b>{title}</b>
      {detail ? <small>{detail}</small> : null}
    </div>
    {action ? <span>{action}</span> : null}
  </button>
)

HomeAttentionRow.propTypes = {
  icon: PropTypes.node,
  tone: PropTypes.oneOf(['warn', 'danger']),
  title: PropTypes.node.isRequired,
  detail: PropTypes.node,
  action: PropTypes.node,
  onClick: PropTypes.func,
}

export default HomeAttentionRow
